import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { JobPricingModels } from 'Douleutaras/types';

const STATS_CATEGORIES_API = 'api/public/v3/stats/categories';

export interface StatsCategory {
  total_assigned_bids_cnt: number;
  category: {
    id: number;
    title: string;
    pricing_model: JobPricingModels;
    is_edge_case_category: boolean;
  };
  subcategory: {
    id: number;
    title: string;
  };
  is_paused: boolean;
  hall_of_fame_report_from: string;
  hall_of_fame_report_to: string;
  reporting_period: number;
}

export const getStatsCategories = createAsyncThunk<Array<StatsCategory>>(
  'stats/categories/get',
  async (args, api) => {
    const response = await makeRequest(
      `${STATS_CATEGORIES_API}/`,
      {
        method: 'GET'
      }
    )(api);

    return response.data.data;
  }
);
